<template>
  <i-modal title="上传文件"
           width="595"
           class="cloud-storage-file-upload"
           :value="isShowed"
           @on-visible-change="changeHandler">
    <i-upload
      class="cover-upload"
      ref="upload"
      multiple
      :show-upload-list="false"
      :max-size="ossUploadParams.max_size"
      type="drag"
      :data="ossUploadParams.data"
      :action="ossUploadParams.host"
      :format="ossUploadParams.format"
      :accept="ossUploadParams.accept"
      :on-exceeded-size="exceededSize"
      :on-format-error="formatError"
      :before-upload="beforeUploadFile"
      :on-success="successUploadFile">
      <button type="button" class="c-button height-40 text-orange-F7B52C  border-radius-4 line line-color-yellow-F7B52C" @click="isShowFileUpload = true">
        <i class="icon-add"></i>
        <span> 上传文件</span>
      </button>
    </i-upload>
    <ul class="list">
      <li class="item" :class="[{'l-margin-top-sm': index === 0}, {'l-margin-top-xs': index > 0}]" v-for="(item, index) in files" :key="index">
        <div class="l-flex-between">
          <div class="l-flex-start l-flex-grow-1">
            <img :src="item.isImg ? item.file_url_cdn : fileType[item.file_type]" class="icon icon-w-h-30">
            <i-input class="cloud-file-name" v-model="item.cloud_file_name" placeholder="输入文件名称"></i-input>
          </div>
          <div class="icon-cancel" @click="deleteFile(index)"></div>
        </div>
      </li>
    </ul>
    <section class="text-mid text-grey-999 width-504 l-margin-top-sm text-pre">支持文件格式：word、excel、ppt、pdf、txt，以及图片、视频
文件大小不超过100MB</section>
    <div slot="footer">
      <div class="l-flex-end l-flex-grow-1">
        <i-button type="text" size="large" @click="cancelModel">取消</i-button>
        <i-button type="primary" size="large" @click="save('fileNameEdit')">保存</i-button>
      </div>
    </div>
  </i-modal>
</template>

<script>

import { Modal, Input, Upload } from 'iview'
import * as MSG from 'assets/data/message.js'
import api from 'modules/member/api/index.js'
import { FILE_TYPE } from 'assets/data/constants.js'
import { setImgFlag } from '@/common/js/utils'

export default {
  name: 'FileUpload',
  data () {
    return {
      files: [],
      ossUploadParams: {
        format: [],
        accept: '',
        expire: 0,
        max_size: 0,
        host: '',
        data: {}
      },
      fileType: FILE_TYPE,
      apiProcessing: false
    }
  },
  computed: {
  },
  props: {
    isShowed: {
      type: Boolean,
      default: false
    },
    folderInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  model: {
    prop: 'isShowed',
    event: 'change-show'
  },
  methods: {
    cancelModel () {
      this.$emit('change-show', false) // 关闭弹窗
    },
    async save (name) {
      // 没有选择文件
      if (this.files.length === 0) {
        this.$store.commit('ADD_MESSAGE', {
          type: 'error',
          msg: '请选择要上传的文件'
        })
        return
      }
      // 重命名文件不允许为空
      const isSomeFileNameNull = this.files.some(item => item.cloud_file_name === '')
      if (isSomeFileNameNull) {
        this.$store.commit('ADD_MESSAGE', {
          type: 'error',
          msg: '请输入文件名称'
        })
        return
      }
      if (this.apiProcessing) {
        this.$store.commit('ADD_MESSAGE', { msg: MSG.GLOBAL_PROCESSING, type: 'error' })
        return false
      }
      this.apiProcessing = true
      // 上传我的文件
      const res = await api.uploadFile({
        parent_folder_id: this.folderInfo && this.folderInfo.id ? this.folderInfo.id : '',
        cloud_file_params: JSON.stringify(this.files)
      })
      if (res.code === 200) {
        this.$store.commit('ADD_MESSAGE', {
          type: 'success',
          msg: '文件上传成功'
        })
        setTimeout(() => {
          this.$emit('confirm', true)
          this.$emit('change-show', false) // 关闭弹窗
          // 上传成功后清空组件的已上传的文件记录
          this.files = []
        }, 2000)
      }
      this.apiProcessing = false
    },
    changeHandler (isShowed) {
      this.$emit('change-show', isShowed)
    },
    deleteFile (index) {
      this.files.splice(index, 1)
    },
    // 文件超出指定大小限制时的钩子
    exceededSize () {
      this.$store.commit('ADD_MESSAGE', {msg: MSG['UPLOAD_EXCEEDED_SIZE'], type: 'error'})
    },
    // 文件格式验证失败时的钩子
    formatError () {
      this.$store.commit('ADD_MESSAGE', {msg: MSG['UPLOAD__FORMAT_ERROR'], type: 'error'})
    },
    successUploadFile (res, file) {
      if (res.code === 200) {
        // 获取文件名，填充输入框
        let fileName = ''
        let fileType = ''
        if (file && file.name) {
          const arr = file.name.split('.')
          fileName = arr[0]
          fileType = arr[arr.length - 1]
        }
        res.results.cloud_file_name = fileName
        res.results.file_type = fileType
        setImgFlag(res.results)
        this.files.push(res.results)
      } else {
        this.$store.commit('ADD_MESSAGE', {msg: res.msg, type: 'error'})
      }
    },
    async beforeUploadFile (file) {
      // TODO: 临时禁用缓存，解决文件上传的覆盖问题
      this.ossUploadParams.expire = 0
      this.ossUploadParams = await api.ossFileParamsCreate(file, 'cloud_file_member', this.ossUploadParams)
    }
  },
  components: {
    'i-input': Input,
    'i-modal': Modal,
    'i-upload': Upload
  }
}
</script>

<style lang="stylus">
.cloud-storage-file-upload
  .icon-cancel
    bg-icon(18px, 18px, '../../assets/cloudstorage/icon-cancel.png')
  .icon-add
    bg-icon(14px, 14px, '../../assets/cloudstorage/icon-add.png')
    margin-right: 6px
  .ivu-btn.ivu-btn-text
    color: #999999
  .ivu-upload.ivu-upload-drag
    display: flex
    justify-content: flex-start
    align-items: center
  .c-button.height-40
    height: 40px
    padding: 0 42px
  .width-504
    width: 504px
  .cloud-file-name
    width: 458px
    margin-left: 14px
</style>



// WEBPACK FOOTER //
// src/components/cloudstorage/FileUpload.vue